import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

export interface UseExtractionBatchTransformedParams {
  extractionBatchId: string;
  trainingSetId?: string;
  enabled?: boolean;
}

export const useExtractionBatchTransformed = (
  { extractionBatchId, trainingSetId, enabled = true }: UseExtractionBatchTransformedParams,
  callbacks?: IRQCallbacks
) => {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['transformerCsv', extractionBatchId, trainingSetId],

    queryFn: async () =>
      await (
        await glynt
      ).extractionBatch.transformer(extractionBatchId, {
        format: 'csv',
        training_sets: trainingSetId,
      }),

    enabled,
    refetchOnWindowFocus: false,
    ...callbacks
  });
};

export default useExtractionBatchTransformed;
